import React, { useEffect, useState,useRef } from "react";
import { useParams,useSearchParams, useNavigate } from "react-router-dom";
import { ManageBranchService } from '../api/services';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import { Modal, Button } from 'react-bootstrap';
const ManageBranch = () => {
  const [searchParams] = useSearchParams();
  const isAd = searchParams.get("isAd") === 'true';
  const [IsLoading, setIsLoading] = useState(false);
  const [titleData, setTitleData] = useState(null);
  const [addTitleorNot, setaddTitleorNot] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [activeTab, setActiveTab] = useState('Title');
  const [titleId, setTitleId] = useState(0);
  const [users, setUsers] = useState([]);
  const [allocatedDevices, setAllocatedDevices] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 10;
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const openAddUserModal = () => setShowAddUserModal(true);
  const closeAddUserModal = () => setShowAddUserModal(false);
  const [showTransactionsModal, setShowTransactionsModal] = useState(false);
  const [transactions, setTransactions] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const [currentUserId, setCurrentUserId] = useState(null);
  const [showPickerModal, setShowPickerModal] = useState(false);
  const [adminData, setAdminData] = useState({});
   //popup
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [deviceShow, setPopupShow] = useState(false);
  const devicePopupClose = () => setPopupShow(false);
  const devicePopupShow = () => setPopupShow(true);

  const [popupDeviceShow, setPopupDeviceShow] = useState(false);
  const handlePopupDeviceClose = () => setPopupDeviceShow(false);
  const handlePopupDeviceShow = () => setPopupDeviceShow(true);
 //DevicesCards
  const [deviceData, setDeviceData] = useState('');
  const [availableDevices, setAvailableDevices] = useState([]);

  const [IsCheckBox, setIsCheckBox] = useState(false);
  const [IsBtnCancel, setIsBtnCancel] = useState(false);
  const [IsBtnDelete, setIsBtnDelete] = useState(false);
  const [IsBtnAddMore, setIsBtnAddMore] = useState(false);

  const [IsAllDelete, setIsAllDelete] = useState(true);
  const [IsCheckAllBox, setIsCheckAllBox] = useState(false);
  const [checked, setChecked] = useState({});
  const [checkedAll, setCheckedAll] = useState(false);
  const [transactionType, setTransactionType] =useState('')
  const transactionTypeRef = useRef("transaction"); 
  const getCurrentMonthYear = () => {
    const now = new Date();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = now.getFullYear();
    return `${month}-${year}`;
  };
  const handleTransactionsClick = (user_Id, transactionType) => {
  setTransactionType(transactionType)
  transactionTypeRef.current = transactionType;
  const currentDate = new Date();
  setSelectedMonth(currentDate);             // reset month to current
  setShowTransactionsModal(true);            // open modal
  fetchTransactionsForMonth(user_Id, currentDate); // fetch transactions
  setCurrentUserId(user_Id);
  };


  const [formData, setFormData] = useState({
    title_name: '',
    card_type: '',
    reacharge_opt_1: '',
    reacharge_opt_2: '',
    reacharge_opt_3: '',
    call_charge: '',
    service_tax: '',
    tariff: '',
    auto_disconnect: ''
  });
  const [addUserFormdata, setaddUserFormdata] = useState({
    user_name:'',
    user_mobile:'',
    user_email:'',
    user_address1:'',
    user_address2:''
  })
  const refs = {
    title_name: useRef(null),
    card_type: useRef(null),
    reacharge_opt_1: useRef(null),
    reacharge_opt_2: useRef(null),
    reacharge_opt_3: useRef(null),
    call_charge: useRef(null),
    service_tax: useRef(null),
    tariff: useRef(null),
    auto_disconnect: useRef(null),
  };
  const refsUser ={
    user_name:useRef(null),
    user_mobile:useRef(null),
    user_email:useRef(null),
    user_address1:useRef(null),
    user_address2:useRef(null)
  }

  const [errors, setErrors] = useState({});
  const [userFormErrors, setuserFormErrors] = useState({})
  const openModal = () => {
      setErrors({}); 
      if (!addTitleorNot && titleData) {
        setFormData({
          title_name: titleData.title_name || '',
          card_type: titleData.card_type || '',
          reacharge_opt_1: titleData.reacharge_opt_1 || '',
          reacharge_opt_2: titleData.reacharge_opt_2 || '',
          reacharge_opt_3: titleData.reacharge_opt_3 || '',
          call_charge: titleData.call_charge || '',
          service_tax: titleData.service_tax || '',
          tariff: titleData.tariff || '',
          auto_disconnect: titleData.auto_disconnect || ''
        });
      } else {
        setFormData({
          title_name: '',
          card_type: '',
          reacharge_opt_1: '',
          reacharge_opt_2: '',
          reacharge_opt_3: '',
          call_charge: '',
          service_tax: '',
          tariff: '',
          auto_disconnect: ''
        });
      }
    setShowModal(true);
  };
  const closeModal = () =>{

     setErrors({});
     setFormData({
          title_name: '',
          card_type: '',
          reacharge_opt_1: '',
          reacharge_opt_2: '',
          reacharge_opt_3: '',
          call_charge: '',
          service_tax: '',
          tariff: '',
          auto_disconnect: ''
      });
      setShowModal(false);
  } 
  function validateUserForm(UserForm){
    const errors = {};
    let validationFlag = true;
    if(UserForm.user_name.trim() === ""){
       errors.user_name ="Name is required";
       validationFlag = false;
    }if(UserForm.user_mobile.trim() === ""){
       errors.user_mobile ="Mobile is required";
       validationFlag = false;
    }if(UserForm.user_email.trim() === ""){
       errors.user_email ="Email is required";
       validationFlag = false;
    }if(UserForm.user_address1.trim() === ""){
       errors.user_address1 ="Address Line 1 is required";
       validationFlag = false;
    }if(UserForm.user_address2.trim() === ""){
       errors.user_address2 ="Address Line 2 is required";
       validationFlag = false;
    }
    errors.validationFlag =  validationFlag
    return errors;
  }
  // vaidate branch data
  function Validation(TitleForm) {
      const errors = {};
      let validationFlag = true;
      
      if (TitleForm.title_name === "") {
      errors.title_name ="Title Name is required";
      validationFlag = false;
      }
      if (TitleForm.card_type === "") {
      errors.card_type = "Card Type is required!";
      validationFlag = false;
      }
      if (TitleForm.reacharge_opt_1 === "") {
      errors.reacharge_opt_1 = "Option 1 is required!";
      validationFlag = false;
      }
      if (TitleForm.reacharge_opt_2 === "") {
      errors.reacharge_opt_2 = "Option 2 is required!";
      validationFlag = false;
      }
      if (TitleForm.reacharge_opt_3 === "") {
      errors.reacharge_opt_3 = "Option 3 is required!";
      validationFlag = false;
      }
      if (TitleForm.call_charge === "") {
        errors.call_charge = "Call Charge is required!";
        validationFlag= false;
      }
       if (TitleForm.service_tax === "") {
        errors.service_tax ="Service Tax is required!";
        validationFlag= false;
      }
       if (TitleForm.tariff === "") {
        errors.tariff = "Pulse is required!";
        validationFlag= false;
      }
       if (TitleForm.auto_disconnect === "") {
        errors.auto_disconnect = "Auto Disconnnect is required!";
        validationFlag= false;
      }
      errors.validationFlag =  validationFlag
      return errors;
  }
   ///submit new branch data
    const handleTitleSubmit = (e) => {
      e.preventDefault();
      debugger;
      const errorMsg = Validation(formData)
      setErrors(errorMsg);
      // Focus the first field that has error
      const firstErrorKey = Object.keys(errorMsg)[0];
      if (firstErrorKey && refs[firstErrorKey]) {
        refs[firstErrorKey].current?.focus();
      }
      if(errorMsg.validationFlag){
          if(addTitleorNot){
              const payload = {
              organization_id: parseInt(organization_id),
              area_id: parseInt(branch_id),
              ...formData,
              auto_disconnect: parseInt(formData.auto_disconnect || 0)
              };
            setIsLoading(true);
            ManageBranchService.addTitle(payload).then((res=>{
                alert("Title Added succesfully")
                getTitleByBranchId();
                setaddTitleorNot(false);
                closeModal();
                setIsLoading(false);

            })).catch((err) => {
                 console.error('Failed to Add title:', err)
                 setIsLoading(false);
            });
           
        }else{
              const payload = {
              Title_id : titleId,
              organization_id: parseInt(organization_id),
              area_id: parseInt(branch_id),
              ...formData,
              auto_disconnect: parseInt(formData.auto_disconnect || 0)
              };
              setIsLoading(true);
              ManageBranchService.editTitle(payload).then((res=>{
                alert("Title Updated succesfully")
                getTitleByBranchId();
                setaddTitleorNot(false);
                closeModal();
                setIsLoading(false);
            })).catch((err) => {
              console.error('Failed to Add title:', err)
              setIsLoading(false);
            } );
        }
      }
        
    };
  // handle user submit
      const handleAddUserSubmit = (e)=>{
         e.preventDefault();
        debugger;
        const errorMsgUser = validateUserForm(addUserFormdata)
        setuserFormErrors(errorMsgUser)
        const firstErrorKey = Object.keys(errorMsgUser)[0];
        if (firstErrorKey && refsUser[firstErrorKey]) {
          refsUser[firstErrorKey].current?.focus();
        }
         if(errorMsgUser.validationFlag){
             const payload = {
                 name:addUserFormdata.user_name,
                 mobile:addUserFormdata.user_mobile,
                 email:addUserFormdata.user_email,
                 address_1:addUserFormdata.user_address1,
                 address_2:addUserFormdata.user_address2,
                 branch_id:branch_id,
                 organization_id:organization_id
              };
            setIsLoading(true);
            ManageBranchService.addBranchuser(payload).then((res=>{
                alert("User Added succesfully")
                closeAddUserModal();
                setActiveTab('Users')
                getUsersByBranchId();
                setIsLoading(false);
            })).catch((err) => {console.error('Failed to Add title:', err)
               setIsLoading(false);
            });
           
         }
      }





  /////
  const handleInputChange = (e) => {
    setFormData(prev => ({
    ...prev,
    [e.target.name]: e.target.value
    }));
  };
  const handleUserInputchange = (e)=>{
      setaddUserFormdata(prev => ({
    ...prev,
    [e.target.name]: e.target.value
    }));
  }
  const { branch_id, organization_id} = useParams();
   
  const navigate = useNavigate();
  const BASE_URL = window.BASE_URL
  useEffect(() => {



    

     if (activeTab === 'Title') {
         getTitleByBranchId();
     }else if(activeTab === 'Users'){
         getUsersByBranchId();
     }else if(activeTab === 'Devices'){
        getDevicesByorgId();
     }
    // let allChecked = true;
    // for (const inputName in checked) {
    //   if (checked[inputName] === false) {
    //     allChecked = false;
    //   }
    // }
    // if (allChecked) {
    //   setCheckedAll(true);
    // } else {
    //   setCheckedAll(false);
    // }
    
  }, [activeTab]);
  //get gettitlebybranchid
  const getTitleByBranchId = () => {
  setIsLoading(true);
  ManageBranchService.getTitleByBranchId({ branch_id: parseInt(branch_id) })
    .then((res) => {
      if (res.data.code === 200) {
        setaddTitleorNot(false);
        setTitleData(res.data.results);
        setTitleId(res.data.results.Title_id)
      } else if (
        res.data.code === 201 &&
        res.data.error_message === 'No Title Registred'
      ) {
        setaddTitleorNot(true);
      }
      setIsLoading(false);
    })
    .catch((err) =>{ console.error('Failed to fetch title:', err)
            setIsLoading(false);
    });
   
  };
  // get users data 
  const getUsersByBranchId=()=>{
    const payload = {
      organization_id :organization_id,
      branch_id: parseInt(branch_id)
    }
    setIsLoading(true);
    ManageBranchService.getUsersByBranchId(payload)
    .then((res)=>{
      if (res.data.code === 200) {
        setUsers(res.data.results);
      } else {
        setUsers([]);
      }
      setIsLoading(false);
    }).catch((err) => {

      console.error('Failed to fetch title:', err)
       setIsLoading(false);
    });
   
  };
  // get devices data
  const getDevicesByorgId = () =>{
    const payload = {
      organization_id :organization_id
    };
    setIsLoading(true);
    ManageBranchService.get_devices(payload)
    .then((res)=>{
        if (res.data.code === 200) {
        setAllocatedDevices(res.data.results);
      } else {
        setAllocatedDevices([]);
      }
      setIsLoading(false);
    }).catch((err) => {
        console.error('Failed to fetch Devices:', err);
        setIsLoading(false);
      });
   
  };
 
  
    function fnCancelClick() {
      fnDevicecommonclosePopup();
      fnCommonClosePopup();
    }
  
    function fnDeviceclosePopup() {
      fnDevicecommonclosePopup();
      fnCommonClosePopup();
      devicePopupClose();
    }
  
    function fnDevicecommonclosePopup() {
      setIsBtnCancel(false);
      setIsBtnDelete(false);
      setIsBtnAddMore(true);
      setIsCheckBox(false);
      setIsAllDelete(true);
    }
  
    function fnCloseAddMorePopup() {
  
      fnCommonClosePopup();
      handlePopupDeviceClose();
    }
  
    function fnCommonClosePopup() {
      setIsCheckAllBox(false);
      setCheckedAll(false);
      setChecked((prevState) => {
        const newState = { ...prevState };
        for (const inputName in newState) {
          newState[inputName] = false;
        }
        return newState;
      });
    }
  
  // Add more devices
  function fnAddMoreClick() {
    debugger
    var data;
    if(isAd){
      data = JSON.stringify({
      "admin_id": sessionStorage.getItem('devicesadminId'),
    });
    }else{
      data = JSON.stringify({
      "admin_id": 0,
    });
    }

    const BASE_URL = window.BASE_URL + '/get_available_devices';
    //setIsLoading(true);
    var config = {
      method: 'post',
      url: BASE_URL,

      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('jwtToken'),
        'Content-Type': 'application/json',
      },
      maxBodyLength: Infinity,
      data: data
    };

    axios.request(config)
      .then((response) => {
        setAvailableDevices([]);
        if (response !== null && response !== undefined && response.data !== null && response.data !== undefined && response.data.results !== null && response.data.results.length > 0) {

          var tempdata = response.data.results;
          setAvailableDevices(tempdata);
          for (var i = 0; i < tempdata.length; i++) {
            var temp = tempdata[i].id;
            checked[temp] = false;
          }
          setCheckedAll(false);
        }
      })
      .catch((error) => {
        // setIsLoading(false);
        console.log(error);
      });

    handlePopupDeviceShow();
  }

//remove devices
const removeDevices = async (reqArr) => {
  const data = JSON.stringify({
    organization_id: parseInt(organization_id),
    device_ids: reqArr
  });

  const BASE_URL = window.BASE_URL + '/remove_devices';

  const config = {
    method: 'post',
    url: BASE_URL,
    headers: {
      'Authorization': 'Bearer ' + localStorage.getItem('jwtToken'),
      'Content-Type': 'application/json',
    },
    maxBodyLength: Infinity,
    data: data
  };

  try {
    setIsLoading(true);

    const response = await axios.request(config);

    if (
      response &&
      response.data &&
      response.data.results
    ) {
      const resp = response.data.results;
      const arrRes = Object.keys(resp).map(i => Number(i));

      const res = allocatedDevices.filter(item => !arrRes.includes(item.id));
      
      setDeviceData(res.length);
      setAllocatedDevices(res);
    }
  } catch (error) {
    console.error(error);
  } finally {
    setIsLoading(false);
  }
};


  const fnRemoveDeviceClick = () => {

    let reqArr = [];
    setChecked((prevState) => {
      const newState = { ...prevState };
      for (let prop in newState) {
        if (newState.hasOwnProperty(prop)) {
          if (newState[prop] === true) {
            reqArr.push(prop);
          }
        }
      }
      if (reqArr !== null && reqArr != [] && reqArr.length > 0) {
        // var data = JSON.stringify({
        //   "admin_id": parseInt(localStorage.getItem('userid')),
        //   "device_ids": reqArr
        // });

        // const BASE_URL = window.BASE_URL + '/remove_devices';
        // //setIsLoading(true);

        // var config = {
        //   method: 'post',
        //   url: BASE_URL,

        //   headers: {
        //     'Authorization': 'Bearer ' + localStorage.getItem('jwtToken'),
        //     'Content-Type': 'application/json',
        //   },
        //   maxBodyLength: Infinity,
        //   data: data
        // };
               
        // setIsLoading(true)
        // axios.request(config)
        //   .then((response) => {

        //     if (response !== null && response !== undefined && response.data !== null && response.data !== undefined && response.data.results !== null) {
        //       let tempArr = [];
        //       tempArr = [...allocatedDevices];
        //       const resp = response.data.results
        //       const arrRes = Object.keys(resp).map(i => Number(i));
        //       let res = tempArr.filter(item => !arrRes.includes(item.id));
        //       setDeviceData(res.length);
        //       setAllocatedDevices(res);
        //       setIsLoading(false);
        //     }
        //   })
        //   .catch((error) => {
        //     setIsLoading(false);
        //     console.log(error);
        //   });
       removeDevices(reqArr);
      }
      return newState;
    });
  }

 function fnRemoveClick() {
    setIsCheckBox(true);
    setIsAllDelete(false);
    setIsCheckAllBox(true);
    setIsBtnAddMore(false);
    setIsBtnDelete(true);
    setIsBtnCancel(true);
  };

      // Devices check box
  function fnCommontoggleclick(inputName, index) {
    setChecked((prevState) => {
      const newState = { ...prevState };
      newState[inputName] = !prevState[inputName];
      return newState;
    });
  }
  //Device checkbox 
  function fnCommonSelectclick(value, deviceList) {
     setCheckedAll(value);

    const newCheckedState = {};
    deviceList.forEach((device) => {
      newCheckedState[device.id] = value;
    });

    setChecked(newCheckedState);
    
  }

    // Add more check boxes
    const toggleCheckDevices = (input, inx) => {
      fnCommontoggleclick(input, inx);
    }
    
    const selectAllDevices = (tempval,availableDevices) => {
      fnCommonSelectclick(tempval, availableDevices)
    }
  
    //Allocate devices
    const fnAllocateNowClick = () => {
  
      let reqArr = [];
  
      setChecked((prevState) => {
        const newState = { ...prevState };
        for (let prop in newState) {
          if (newState.hasOwnProperty(prop)) {
            if (newState[prop] === true) {
              reqArr.push(prop);
            }
          }
        }
  
        if (reqArr !== null && reqArr != [] && reqArr.length > 0) {
          var data = JSON.stringify({
            "admin_id": parseInt(localStorage.getItem('userid')),
            "device_ids": reqArr,
            "organization_id":organization_id,
            "area_id":branch_id
          });
  
          const BASE_URL = window.BASE_URL + '/allocate_device';
          //setIsLoading(true);
  
          var config = {
            method: 'post',
            url: BASE_URL,
  
            headers: {
              'Authorization': 'Bearer ' + localStorage.getItem('jwtToken'),
              'Content-Type': 'application/json',
            },
            maxBodyLength: Infinity,
            data: data
          };
          setIsLoading(true);
          axios.request(config)
            .then((response) => {
              if (response !== null && response !== undefined && response.data !== null && response.data !== undefined && response.data.results !== null) {
                let tempArr = [];
                let tempRes = [];
                tempArr = [...availableDevices];
                const resp = response.data.results
                let arrRes = Object.keys(resp).map(i => Number(i));
                let tempAvailableD = tempArr.filter(item => !arrRes.includes(item.id));
                const tempAllocatedD = tempArr.filter(index => {
                  return arrRes.find(selected => selected === index.id)
                });
                tempRes = [...allocatedDevices, ...tempAllocatedD];
                setAllocatedDevices(tempRes);
                setDeviceData(tempRes.length);
                setAvailableDevices(tempAvailableD);
                setIsLoading(false);
              }
            })
            .catch((error) => {
              setIsLoading(false);
              console.log(error);
            });
        }
        return newState;
      });
    }
  const toggleCheck = (input, inx) => {
    fnCommontoggleclick(input, inx)
  };

  const selectAll = (tempval) => {
    fnCommonSelectclick(tempval, allocatedDevices)
  };

  // Pagination Logic
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = users.slice(indexOfFirstUser, indexOfLastUser);
  const totalPages = Math.ceil(users.length / usersPerPage);
  const formatMonthYear = (date) => {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${month}-${year}`;
};

  const getMonthLabel = (date) => {
    return date.toLocaleString('default', { month: 'long', year: 'numeric' });
  };

  const fetchTransactionsForMonth = (userId, date) => {
    const payload = {
      user_id: userId,
      month: formatMonthYear(date),
    };
    if(transactionTypeRef.current  === 'transaction'){
      setIsLoading(true);
      ManageBranchService.get_user_transactions(payload)
      .then((res) => {
        setTransactions(res.data.results || []);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error('Failed to fetch transactions:', err);
        setTransactions([]);
        setIsLoading(false);
      });
      
    }else{
      /// card recharges
      setIsLoading(true);
      ManageBranchService.get_card_transactions(payload)
      .then((res) => {
        setTransactions(res.data.results || []);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error('Failed to fetch transactions:', err);
        setTransactions([]);
        setIsLoading(false);
      });
     

    }

    
  };

  const handleMonthChange = (direction) => {
    const newDate = new Date(selectedMonth);
    newDate.setMonth(selectedMonth.getMonth() + direction);
    setSelectedMonth(newDate);
    fetchTransactionsForMonth(currentUserId, newDate);
  };
const renderDatepickerModal = () =>(
    showPickerModal && (
  <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content rounded">
        <div className="modal-header">
          <h5 className="modal-title fw-bold">Select Month</h5>
          <button type="button" className="btn-close" onClick={() => setShowPickerModal(false)}></button>
        </div>
        <div className="modal-body text-center">
          <DatePicker
            selected={selectedMonth}
            onChange={(date) => setSelectedMonth(date)}
            dateFormat="MM/yyyy"
            showMonthYearPicker
            inline
          />
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={() => setShowPickerModal(false)}>Cancel</button>
          <button
            className="btn btn-primary"
            onClick={() => {
              fetchTransactionsForMonth(currentUserId, selectedMonth);
              setShowPickerModal(false);
            }}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  </div>
)

);

 const renderTransactionModal = () => (
  
  showTransactionsModal && (
    <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered modal-xl">
        <div className="modal-content rounded">
          <div className="modal-header CommonColor text-white">
            <h5 className="modal-title">Transactions</h5>
            <button type="button" className="btn-close" onClick={() => setShowTransactionsModal(false)}></button>
          </div>

          <div className="modal-body">
            {/* Month Navigation */}
            <div className="d-flex justify-content-center align-items-center mb-3">
              <button className="btn CommonColor text-white rounded-circle me-2" onClick={() => handleMonthChange(-1)}>
                &#8592;
              </button>
              <div
                  className="CommonColor px-4 py-2 rounded text-white fw-bold text-center"
                  style={{ cursor: "pointer", minWidth: 200 }}
                  onClick={() => setShowPickerModal(true)}
                >
                   {getMonthLabel(selectedMonth)}
                </div>





              {/* <div className="bg-warning px-4 py-2 rounded text-white fw-bold">
                {getMonthLabel(selectedMonth)}
              </div> */}
              <button className="btn CommonColor text-white rounded-circle ms-2" onClick={() => handleMonthChange(1)}>
                &#8594;
              </button>
            </div>

            {/* Table or No Data */}
            {transactions.length === 0 ? (
              <p className="text-center text-muted">No transactions found.</p>
            ) : (
              <div className="table-responsive">
                <table className="table table-bordered table-hover">
                  <thead className="table-warning">
                    <tr>
                      <th>Date</th>
                      <th>Transaction ID</th>
                      <th>By</th>
                      <th>To</th>
                      <th>Amount</th>
                      <th>Type</th>
                    </tr>
                  </thead>
                  <tbody>
                    {transactions.map((txn) => (
                      <tr key={txn.transaction_id}>
                        <td>{txn.transaction_time}</td>
                        <td>{txn.transaction_id}</td>
                        <td>{txn.by_name}</td>
                        <td>{txn.to_name}</td>
                        <td>{txn.amount}</td>
                        <td>{txn.transaction_type}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
    
  )
);

const renderDevicesPopup = () => (
    <>
      {/* Device Popup */}
      <Modal show={deviceShow} onHide={fnDeviceclosePopup} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>Super Admin</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table className="">
            <thead>
              <tr>
                <th>Devices</th>
                <th>
                  <Button style={IsAllDelete ? {} : { display: 'none' }} variant="secondary" onClick={fnRemoveClick}>
                    Delete
                  </Button>
                  <input
                    style={IsCheckAllBox ? {} : { display: 'none' }}
                    type="checkbox"
                    onChange={(event) => selectAll(event.target.checked)}
                    checked={checkedAll}
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              {allocatedDevices.map((Data, idx) => (
                <tr className="" key={idx}>
                  <td>{Data.name}</td>
                  <td style={IsCheckBox ? {} : { display: 'none' }}>
                    <input type="checkbox" onChange={() => toggleCheck(Data.id, idx)} checked={checked[Data.id]} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          {IsBtnCancel && (
            <Button variant="secondary" onClick={fnCancelClick}>
              Cancel
            </Button>
          )}
          {IsBtnDelete && (
            <Button variant="secondary" onClick={fnRemoveDeviceClick}>
              Delete
            </Button>
          )}
         
        </Modal.Footer>
      </Modal>

      {/* Allocate Devices Popup */}
      <Modal show={popupDeviceShow} onHide={fnCloseAddMorePopup} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>Allocate Devices</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table className="">
            <thead>
              <tr>
                <th>Select All</th>
                <th>
                  <input
                    type="checkbox"
                    onChange={(event) => selectAllDevices(event.target.checked,availableDevices)}
                    checked={checkedAll}
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              {availableDevices.map((Data, idx) => (
                <tr key={idx}>
                  <td>{Data.name}</td>
                  <td>
                    <input type="checkbox" onChange={() => toggleCheckDevices(Data.id, idx)} checked={checked[Data.id] || false} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="btncommonColor" onClick={fnAllocateNowClick}>
            Allocate Now
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );


  return (
  <div className="container mt-4">
    {/* Loader */}
    <div className="loader" style={IsLoading ? {} : { display: 'none' }}>
        <div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
      </div>
    {/* Header */}
    <div className="CommonColor p-3 rounded-top shadow-sm ">
       <button
      className="btn btn-outline-secondary mb-3"
       onClick={() => navigate(-1)}>
        ← Back
    </button>
      <h4 className="mb-0 ">Manage Branch</h4>
    </div>

    {/* Buttons */}
    <div className="d-flex gap-3 mt-3">
     <button className="btn btn-outline-primary w-100" onClick={openModal}> 
        {addTitleorNot ? 'Add Title' : 'Edit Title'}
      </button>
        <button className="btn btn-outline-secondary w-100" onClick={openAddUserModal}>Add User</button>
    </div>

    {/* Tabs */}
    <ul className="nav nav-tabs mt-4">
      {['Title', 'Users', 'Devices'].map(tab => (
        <li className="nav-item" key={tab}>
          <button
            className={`nav-link ${activeTab === tab ? 'active' : ''}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        </li>
      ))}
    </ul>

    {/* Tab Content */}
    {activeTab === 'Title' && (
      <div className="card p-4 mt-3 shadow-sm">
        <h5 className="mb-3">Title Info</h5>
        <div className="mb-2"><strong>Title Name:</strong> <span>{titleData?.title_name || ''}</span></div>
        <div className="mb-2"><strong>Card Type:</strong> <span>{titleData?.card_type || ''}</span></div>

        <h5 className="mt-4 mb-3">Recharge Options</h5>
        <div className="mb-2"><strong>Recharge Option 1:</strong> <span>{titleData?.reacharge_opt_1 || ''}</span></div>
        <div className="mb-2"><strong>Recharge Option 2:</strong> <span>{titleData?.reacharge_opt_2 || ''}</span></div>
        <div className="mb-2"><strong>Recharge Option 3:</strong> <span>{titleData?.reacharge_opt_3 || ''}</span></div>

        <h5 className="mt-4 mb-3">Call Plan</h5>
        <div className="mb-2"><strong>Call Charge:</strong> <span>{titleData?.call_charge || ''}</span></div>
        <div className="mb-2"><strong>Service Tax:</strong> <span>{titleData?.service_tax || ''}</span></div>
        <div className="mb-2"><strong>Pulse (in Sec):</strong> <span>{titleData?.tariff || ''}</span></div>
        <div className="mb-2"><strong>Auto Disconnect (in Sec):</strong> <span>{titleData?.auto_disconnect || ''}</span></div>
      </div>
    )}

  { activeTab === 'Users' && (
      <div className="card p-4 mt-3 shadow-sm">
         <h5 className="mb-3">Users</h5>
        <div className="divTblStyle">
          <div className="table-wrapper">
            <div className="table-responsive">
                <table className="tblStyle">
                  <thead className="">
                    <tr className="theadtrStyle">
                      <th className="thStyle">Name</th>
                      <th className="thStyle">Mobile</th>
                      <th className="thStyle">Email</th>
                      <th className="thStyle">Address</th>
                      <th className="thStyle">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentUsers.length === 0 ? (
                      <tr>
                        <td colSpan="5" className="text-center">No users found.</td>
                      </tr>
                    ) : (
                      currentUsers.map((user, index) => (
                        <tr key={user.branch_user_id}>
                          <td className="tdStyle">{user.name}</td>
                          <td className="tdStyle">{user.mobile}</td>
                          <td className="tdStyle">{user.email}</td>
                          <td className="tdStyle">{user.address_1}, {user.address_2}</td>
                          <td className="tdStyle">
                            <div className="d-flex justify-content-center gap-2 flex-wrap">
                              <button
                                  className="btn btncommonColor text-white"
                                  onClick={() => handleTransactionsClick(user.user_id,"transaction")}>
                                  Transactions
                                </button>
                                <button className="btn btncommonColor text-white"
                                  onClick={() => handleTransactionsClick(user.user_id,"cardrecharge")}>
                                  Card Recharges
                                </button>
                            </div>
                        </td>

                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
        </div>
             </div>
                     </div>
        {/* Pagination Controls */}
        {users.length > usersPerPage && (
          <div className="d-flex justify-content-center mt-3">
            <button
              className="btn btn-sm btn-outline-primary mx-2"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(prev => prev - 1)}
            >
              Previous
            </button>
            <span className="align-self-center mt-1">
              Page {currentPage} of {totalPages}
            </span>
            <button
              className="btn btn-sm btn-outline-primary mx-2"
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(prev => prev + 1)}
            >
              Next
            </button>
          </div>
        )}
      </div>
    )}


  {activeTab === 'Devices' && (
    <div className="card p-4 mt-3 shadow-sm">
      <div   className="d-flex justify-content-between align-items-center mb-1">
          <h5 className="mb-3">Devices</h5>
          <div className="d-flex justify-content-between align-items-center mb-1 gap-2">
            <button className="btn btn-secondary text-white fw-bold" onClick={() => devicePopupShow()}>Delete Devices</button>
            <button  className="btn btncommonColor text-white fw-bold" onClick={() => fnAddMoreClick()}>Add Devices</button>
          </div>
          
      </div>
       <div className="divTblStyle">
        <div className="table-wrapper">
          <div className="table-responsive">
            <table className="tblStyle">
                <thead >
                <tr className="theadtrStyle">
                  <th className="thStyle">Name</th>
                  <th className="thStyle">Code</th>
                </tr>
              </thead>
              <tbody>
                {allocatedDevices.length === 0 ? (
                  <tr>
                    <td colSpan="2" className="text-center">No devices found</td>
                  </tr>
                ) : (
                  allocatedDevices.map((device, idx) => (
                    <tr key={device.id || idx}>
                      <td className="tdStyle">{device.name}</td>
                      <td className="tdStyle">{device.code}</td>
                    </tr>
                  ))
                )}
              </tbody>
                </table>
          </div>
        </div>
      </div>
    </div>
  )}


  {activeTab === 'Cards' && (
    <div className="card p-4 mt-3 shadow-sm">
      <h5 className="mb-0">Cards tab content here...</h5>
    </div>
  )}

    {/* Modal Title */}
    {showModal && (
      <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded">
            <div className="modal-header CommonColor text-white">
              <h5 className="modal-title">{addTitleorNot ? 'Register Title' : 'Edit Title'}</h5>
              <button type="button" className="btn-close" onClick={() => closeModal(false)}></button>
            </div>

            {/* Form Start */}
            <form onSubmit={handleTitleSubmit}>
              <div className="modal-body">
                <div className="mb-2">
                  <label className="form-label mt-2">Title Name</label>
                  <input type="text"  ref={refs.title_name} name="title_name" value={formData.title_name} onChange={handleInputChange} className="form-control" />
                  {errors.title_name && <span className="span-error">{errors.title_name}</span>}
                </div>
                <div className="mb-2">
                  <label className="form-label mt-2">Card Type</label>
                  <input type="text"  ref={refs.card_type} name="card_type" value={formData.card_type} onChange={handleInputChange} className="form-control" />
                  {errors.card_type && <span className="span-error">{errors.card_type}</span>}
                </div>
                <div className="mb-2">
                  <div className="mt-4 text-center fw-bold">Recharge Options</div>
                  <div className="d-flex gap-2 mt-2">

                      <div className="flex-fill">
                        <input type="text"
                          ref={refs.reacharge_opt_1}
                          name="reacharge_opt_1"
                          value={formData.reacharge_opt_1}
                          onChange={handleInputChange}
                          className="form-control"
                          placeholder="Option 1"
                        />
                        {errors.reacharge_opt_1 && (
                          <span className="span-error">{errors.reacharge_opt_1}</span>
                        )}
                      </div>

                      <div className="flex-fill">
                        <input type="text"
                          ref={refs.reacharge_opt_2}
                          name="reacharge_opt_2"
                          value={formData.reacharge_opt_2}
                          onChange={handleInputChange}
                          className="form-control"
                          placeholder="Option 2"
                        />
                        {errors.reacharge_opt_2 && (
                          <span className="span-error">{errors.reacharge_opt_2}</span>
                        )}
                      </div>

                      <div className="flex-fill">
                        <input type="text"
                          ref={refs.reacharge_opt_3}
                          name="reacharge_opt_3"
                          value={formData.reacharge_opt_3}
                          onChange={handleInputChange}
                          className="form-control"
                          placeholder="Option 3"
                        />
                        {errors.reacharge_opt_3 && (
                          <span className="span-error">{errors.reacharge_opt_3}</span>
                        )}
                      </div>
                    </div>
                </div>
                
                <div className="mt-4 fw-bold text-center">Call Plan</div>
                 <div className="mb-2">
                   <label className="form-label mt-2">Call Charge</label>
                   <input type="text"  ref={refs.call_charge} name="call_charge" value={formData.call_charge} onChange={handleInputChange} className="form-control" />
                    {errors.call_charge && <span className="span-error">{errors.call_charge}</span>}
                 </div>
                <div className="mb-2">
                  <label className="form-label mt-2">Service Tax</label>
                  <input  type="text"  ref={refs.service_tax} name="service_tax" value={formData.service_tax} onChange={handleInputChange} className="form-control" />
                   {errors.service_tax && <span className="span-error">{errors.service_tax}</span>}
                </div>
                <div className="mb-2">
                  <label className="form-label mt-2">Pulse (in Sec)</label>
                  <input type="text"  ref={refs.tariff} name="tariff" value={formData.tariff} onChange={handleInputChange} className="form-control" />
                  {errors.tariff && <span className="span-error">{errors.tariff}</span>}
                </div>
                <div className="mb-2">
                  <label className="form-label mt-2">Auto Disconnect (in Sec)</label>
                  <input type="text"   ref={refs.auto_disconnect} name="auto_disconnect" value={formData.auto_disconnect} onChange={handleInputChange} className="form-control" />
                   {errors.auto_disconnect && <span className="span-error">{errors.auto_disconnect}</span>}
                </div>
              </div>

              <div className="modal-footer">
                <button type="submit" className="btn btncommonColor  text-white fw-bold">
                  Submit
                </button>
              </div>
            </form>
            {/* Form End */}
          </div>
        </div>
      </div>
    )}
    {/* {Add user MOdel} */}
    {showAddUserModal && (
  <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content rounded">
        <div className="modal-header CommonColor text-white">
          <h5 className="modal-title">Register Branch User/Agent</h5>
          <button type="button" className="btn-close" onClick={() => setShowAddUserModal(false)}></button>
        </div>

        {/* Form Start */}
        <form onSubmit={handleAddUserSubmit}>
          <div className="modal-body">
            <div className="mb-2">
              <label className="form-label mt-2">Name</label>
              <input
                type="text"
                ref={refsUser.user_name}
                name="user_name"
                value={formData.name}
                onChange={handleUserInputchange}
                className="form-control"
              />
              {userFormErrors.user_name && <span className="span-error">{userFormErrors.user_name}</span>}
            </div>

            <div className="mb-2">
              <label className="form-label mt-2">Mobile Number</label>
              <input
                type="text"
                ref={refsUser.user_mobile}
                name="user_mobile"
                value={formData.mobile}
                onChange={handleUserInputchange}
                className="form-control"
                maxLength={10}
              />
              {userFormErrors.user_mobile && <span className="span-error">{userFormErrors.user_mobile}</span>}
            </div>

            <div className="mb-2">
              <label className="form-label mt-2">Email</label>
              <input
                type="email"
                ref={refsUser.user_email}
                name="user_email"
                value={formData.email}
                onChange={handleUserInputchange}
                className="form-control"
              />
              {userFormErrors.user_email && <span className="span-error">{userFormErrors.user_email}</span>}
            </div>

            <div className="mb-2">
              <label className="form-label mt-2">Address Line 1</label>
              <input
                type="text"
                ref={refsUser.user_address1}
                name="user_address1"
                value={formData.address1}
                onChange={handleUserInputchange}
                className="form-control"
              />
               {userFormErrors.user_address1 && <span className="span-error">{userFormErrors.user_address1}</span>}
            </div>

            <div className="mb-2">
              <label className="form-label mt-2">Address Line 2</label>
              <input
                type="text"
                ref={refsUser.user_address2}
                name="user_address2"
                value={formData.address2}
                onChange={handleUserInputchange}
                className="form-control"
              />
             {userFormErrors.user_address2 && <span className="span-error">{userFormErrors.user_address2}</span>}
            </div>
          </div>

          <div className="modal-footer">
            <button type="submit" className="btn btncommonColor text-white fw-bold">
              Submit
            </button>
          </div>
        </form>
        {/* Form End */}
      </div>
    </div>
  </div>
    )}
    {renderTransactionModal()}
    {renderDatepickerModal()}
    {renderDevicesPopup()}
  </div>
);

};

export default ManageBranch;
